const emptyField = 'Se requiere rellenar este campo!'
const onlyLetters = 'Debe ingresar solo letras!'
const onlyNumbers = 'Sólo se admiten números!'
const indentificationCCValidation = 'La longitud del campo identificación debe ser mayor a 5 y menor que 11'
const indentificationCEValidation = 'La longitud del campo identificación debe ser mayor a 3 y menor que 11'
const onlyUpperLettersAndNumbers = 'Solo se admiten números y letras mayusculas!'
const onlyTenNumbers = 'Se requiere ingresar 10 números!'
const selectType = 'Se requiere seleccionar el tipo de identificación!'
const invalidEmail = 'Email invalido'
const invalidIdentification = 'La cédula no es válida'
const invalidRegionIdentification='Esta cédula no pertenece a ninguna región'
const onlyCCPhone='Se requiere ingresar 09'
const validateBirthday='Se requiere ingresar mayores de edad'
const registerSuccess='registrado correctamente'
const updateSuccess='modificado correctamente'
const deleteSuccess='Eliminado correctamente'
const validatePasswordLength='Debe tener mas de 8 a 14 caracteres'
const validatePasswordCapitalLetter='Debe tener una mayúscula'
const validatePasswordNumber='Debe tener un número'
const validatePassword='Ingresar contraseña'
const validatePasswords='Las contraseñas no son las mismas'
const termsAndConditions='Debe aceptar los términos y condiciones'
const validatelenght= 'Debe tener solo un caracter'

const validateDecimals= 'Debe ingresar punto para decimales'

const eliminateSuccess = 'Eliminado correctamante'

const updateButton = 'Actualizar'
const deleteButton = 'Eliminar'
const inactiveButton = 'Inactivar'
const establishmentButton = 'Agregar establecimientos'
const organizationButton = 'Agregar organizaciones'
const emissionButton = 'Agregar fuentes de emisión'
const linkButton = 'Copiar url para que puedan resetear la contraseña'
const pcg = 'Agregar PCG'
const typeEvent = 'Agregar tipo de eventos'
const typeOrganization = 'Agregar tipo de organización'

const view = 'Visualizar'

const registerUser = 'Agregar usuario'

const registerPortfolio = 'Agregar portafolio'

const registerGeiPortfolio = 'Agregar portafolio GEI'

const validateMessages = {
    registerGeiPortfolio,
    registerPortfolio,
    typeOrganization,
    pcg,
    typeEvent,
    organizationButton,
    inactiveButton,
    linkButton,
    emissionButton,
    updateButton,
    establishmentButton,
    deleteButton,
    emptyField,
    onlyLetters,
    onlyNumbers,
    indentificationCCValidation,
    onlyUpperLettersAndNumbers,
    indentificationCEValidation,
    onlyTenNumbers,
    invalidEmail,
    selectType,
    invalidIdentification,
    invalidRegionIdentification,
    onlyCCPhone,validateBirthday,
    registerSuccess,
    updateSuccess,
    validatePasswordLength,
    validatePasswordCapitalLetter,
    validatePasswordNumber,
    validatePassword,
    validatePasswords,
    termsAndConditions,
    validatelenght,
    deleteSuccess,
    validateDecimals,
    eliminateSuccess,
    view,
    registerUser
};

export default validateMessages;